import React from 'react';

export const FormContainer = (props) => {
   const sizeColumn = props.sizeColumn;
   return (
      <section className='section'>
         <div className='columns is-vcentered is-centered'>
            <div className={`column ${sizeColumn}`}>{props.children}</div>
         </div>
      </section>
   );
};
